import { gql } from '@apollo/client';
import React from 'react';
import { useDispatch } from 'react-redux';
import { MenuItem } from '../components/Menu';
import type { GroupSubgroupCard_GroupFragment } from '../graphql/generated/graphqlTypes';
import UIActions from '../ui/UIActions';
import groupPath from '../utils/url/groupPath';
import GroupCardAvatarStack from './GroupCardAvatarStack';
import GroupChildCard from './GroupChildCard';
import trashIcon from '../icons/trash.svg';

const GROUP_SUBGROUP_CARD_FRAGMENT = gql`
  fragment GroupSubgroupCard_group on Group {
    id
    name
    members {
      id
    }
    owners {
      id
    }
    ...groupPath_group
    ...GroupCardAvatarStack_group
  }
  ${groupPath.fragments.group}
  ${GroupCardAvatarStack.fragments.group}
`;

interface GroupSubgroupCardProps {
  group: GroupSubgroupCard_GroupFragment;
  onRemove?: () => Promise<unknown>;
}

const GroupSubgroupCard = ({ group, onRemove }: GroupSubgroupCardProps) => {
  const dispatch = useDispatch();
  const { name, members, owners } = group;
  const hasUsers = members.length > 0 || owners.length > 0;

  const showToast = (message: string) => {
    dispatch(
      UIActions.pushToast({
        level: 'success',
        message,
      }),
    );
  };

  return (
    <GroupChildCard
      to={groupPath(group) || ''}
      avatars={hasUsers ? <GroupCardAvatarStack group={group} /> : null}
      title={name}
      description="Group"
      menuItems={
        onRemove && (
          <MenuItem
            danger
            icon={trashIcon}
            onClick={() =>
              onRemove().then(() =>
                showToast(`${name} has been removed from the group.`),
              )
            }
          >
            Remove group
          </MenuItem>
        )
      }
    />
  );
};

GroupSubgroupCard.fragments = {
  group: GROUP_SUBGROUP_CARD_FRAGMENT,
};

export default GroupSubgroupCard;
